var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect } from 'react';
import { SmartCheck, SmartChatTypes, AuthTypes } from '../states';
import { formatPhone } from '../utils';
import { PHONE_VALIDATION_SUCCESS_MESSAGE_2, PHONE_VALIDATION_SUCCESS_MESSAGE_1 } from '../Constants';
import { sendMessageWithTypingDecorator } from '../decorators';
import { useSession } from '@lendi/lala-react';
export var useRequestCode = function (chatState, authDispatch, chatDispatch) {
    var phoneNumber = chatState.phoneNumber, checkpoint = chatState.checkpoint, messages = chatState.messages;
    var sendCode = useSession().sendCode;
    function initiateRequestCode() {
        return __awaiter(this, void 0, void 0, function () {
            var oldIndex;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        oldIndex = messages.length > 0 ? messages[messages.length - 1].index : 0;
                        return [4 /*yield*/, sendMessageWithTypingDecorator(chatDispatch, PHONE_VALIDATION_SUCCESS_MESSAGE_1, ++oldIndex)];
                    case 1:
                        _a.sent();
                        chatDispatch({ type: SmartChatTypes.NEXT_SMART_STATE, payload: SmartCheck.ON_NEW_CUSTOMER_CHECK });
                        return [2 /*return*/];
                }
            });
        });
    }
    function resendCode() {
        return __awaiter(this, void 0, void 0, function () {
            var oldIndex, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        authDispatch({ type: AuthTypes.SEND_CODE });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, sendCode(phoneNumber)];
                    case 2:
                        _a.sent();
                        authDispatch({ type: AuthTypes.SENT_CODE });
                        oldIndex = messages.length > 0 ? messages[messages.length - 1].index : 0;
                        // if existingCustomerCheck is already done (like if you request the code again, then no need to check for existingCustomerCheck, so skip the Name and email check and go to code validation,)
                        return [4 /*yield*/, sendMessageWithTypingDecorator(chatDispatch, "".concat(PHONE_VALIDATION_SUCCESS_MESSAGE_2, " ").concat(formatPhone(phoneNumber)), ++oldIndex)];
                    case 3:
                        // if existingCustomerCheck is already done (like if you request the code again, then no need to check for existingCustomerCheck, so skip the Name and email check and go to code validation,)
                        _a.sent();
                        chatDispatch({ type: SmartChatTypes.NEXT_SMART_STATE, payload: SmartCheck.ON_CODE_VALIDATION_CHECK });
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        chatDispatch({ type: SmartChatTypes.SET_PREVIOUS_CHECKPOINT_BEFORE_ERROR });
                        authDispatch({ type: AuthTypes.ERROR, payload: err_1 });
                        chatDispatch({ type: SmartChatTypes.NEXT_SMART_STATE, payload: SmartCheck.ON_ERROR_CHECK });
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    useEffect(function () {
        if (checkpoint === SmartCheck.ON_REQUEST_CODE_CHECK) {
            initiateRequestCode();
        }
    }, [checkpoint]);
    useEffect(function () {
        if (checkpoint === SmartCheck.ON_CODE_RESEND_CHECK) {
            resendCode();
        }
    }, [checkpoint]);
};
//# sourceMappingURL=useRequestCode.js.map